import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/img-no-igredient-candidate.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-1943ffc7")

_pushScopeId("data-v-1943ffc7")
const _hoisted_1 = { class: "shoppinglistappendingredientcategorylistitem" }
const _hoisted_2 = {
  key: 0,
  class: "shoppinglistappendingredientcategorylistitem-existdata"
}
const _hoisted_3 = {
  key: 0,
  class: "shoppinglistappendingredientcategorylistitem-existdata-zero"
}
const _hoisted_4 = { class: "shoppinglistappendingredientcategorylistitem-existdata-zero-contents" }
const _hoisted_5 = /*#__PURE__*/_createVNode("img", {
  class: "shoppinglistappendingredientcategorylistitem-existdata-zero-contents-image",
  src: _imports_0
}, null, -1)
const _hoisted_6 = { class: "shoppinglistappendingredientcategorylistitem-existdata-zero-contents-message" }
const _hoisted_7 = { class: "shoppinglistappendingredientcategorylistitem-existdata-zero-contents-message-text" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_SelectingIngredientList = _resolveComponent("SelectingIngredientList")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.ingredientList)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          (_ctx.ingredientList.length==0)
            ? (_openBlock(), _createBlock("div", _hoisted_3, [
                _createVNode("div", _hoisted_4, [
                  _hoisted_5,
                  _createVNode("div", _hoisted_6, [
                    _createVNode("span", _hoisted_7, _toDisplayString(_ctx.nodataMessage), 1)
                  ])
                ])
              ]))
            : (_openBlock(), _createBlock("div", {
                key: 1,
                class: "shoppinglistappendingredientcategorylistitem-existdata-nozero",
                onScrollPassive: _cache[1] || (_cache[1] = $event => _ctx.onScroll($event))
              }, [
                _createVNode(_component_SelectingIngredientList, {
                  key: _ctx.updateDisplayKey,
                  ingredientList: _ctx.ingredientList,
                  onOnSelect: _ctx.checkFoodAction
                }, null, 8, ["ingredientList", "onOnSelect"])
              ], 32))
        ]))
      : _createCommentVNode("", true)
  ]))
})